/* eslint-disable max-len */

/** フロントエンド URL */
const FRONT_DOMAIN = 'localhost';
const FRONT_URL = `https://${FRONT_DOMAIN}`;

/** バックエンドエンド URL */
const API_ENV = 'int'; // 内部用
// const API_ENV = 'ext'; // 外部用
const BACK_DOMAIN = `${API_ENV}.api.dev.tkts.denryoku-nes.com`;
const API_URL = `https://${BACK_DOMAIN}/`;

// ローカル実行API(SpringBoot)用
// const API_URL = `http://localhost:8080/`;

// NOTE: Windowsの環境変数 REACT_APP_DEFAULT_USER にJSON形式で定義すると、ログイン画面の初期入力値として設定される
// 例: {"id": "user01", "password": "123456a?"}
let defaultUser;
const userEnv = process.env.REACT_APP_DEFAULT_USER;
try {
  defaultUser = userEnv ? JSON.parse(userEnv) : undefined;
} catch (err) {
  console.warn(`Invalid ENV: REACT_APP_DEFAULT_USER is "${userEnv}".`);
}


export default {
  'logger': false,
  'consolelog': true,
  'API_URL': API_URL,
  'WIJMO_LICENSE_KEY': `${FRONT_DOMAIN},216563957986396#B0mjaiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34zZtdmTD5EaKNmd7gGcz8EMCRnVEFVTrkTc9hTYupEam3yU55WRmVDd8AHT5V5V8NHVStENRpGd6RWUSlme0pEWGNUZalUMC9WSWVzV5N7VrgVMxg7KVtyTsZGc8Qnc78WakhzaFpVeyU7c8JlU4UlRZBDOzdmQXNEaGt4NDZETQZGbY3GV7oFbZVDRONGRP5WU8R4dW3iUBVjMhl4a0VVO5h6b62WSxgHTrkDT6FVe4MjRuVXV4dGcrgzM7hFMDFkYmVVS6syZEhVawhma4FzYyQUNtNUS9B5M6FTQVRlRIRFe7MGUX3ESYV7Zsd4dlhkSBFHTjhFUwhUR6Y6RMlET6gXYHdUdL56KZtUQLF5amZFZIF7NEdkc0NHSLtSUrk5YUJWRTlzUUhUTudESkZGNXhEbZZVNON7VzEkSl3SVHpkMRZHSvMFVBtmT8cXavJkY0BzdSRkI0IyUiwiI5gTN6QDRzEjI0ICSiwCO6cTN5QTN0IicfJye&Qf35VfikEMyIlI0IyQiwiIu3Waz9WZ4hXRgACdlVGaThXZsZEIv5mapdlI0IiTisHL3JSNJ9UUiojIDJCLi86bpNnblRHeFBCIyV6dllmV4J7bwVmUg2Wbql6ViojIOJyes4nILdDOIJiOiMkIsIibvl6cuVGd8VEIgc7bSlGdsVXTg2Wbql6ViojIOJyes4nI4YkNEJiOiMkIsIibvl6cuVGd8VEIgAVQM3EIg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyes4nIVhzNBJiOiMkIsIibvl6cuVGd8VEIgQnchh6QsFWaj9WYulmRg2Wbql6ViojIOJyebpjIkJHUiwiI8QDMyIDMgEjMyADNyAjMiojI4J7QiwiI4N7boxWYj3GbiojIz5GRiwiI+S09ayL9Pyb9qCq9/K882O88ZO88OO88kK88zO88nO887K882O88lO88qO883K88DVkTiojIh94QiwiI6kzM6gTO7UTOzYTN6EjMiojIklkIs4XXbpjInxmZiwiIym5yy`,
  'MANUAL_PDF_URL': `${FRONT_URL}/manual/manual.pdf`,

  /** ログイン画面 初期入力ユーザー情報 */
  defaultUser,

  /** Cognito認証設定 */
  'amplify_conf': {
    Auth: {
      // REQUIRED - Amazon Cognito Region
      region: 'ap-northeast-1',
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: 'ap-northeast-1_5Hrkpht7u',
      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: '206gm5rvjk3vjhpp3290pj8cja',
      // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
      mandatorySignIn: false,
    },
  },
};
